import { Injectable } from "@angular/core";
import { navigateToUnsupported } from "../../utils/unsupported";

@Injectable({
  providedIn: "root",
})
export class BaseAppInitService {
  protected checkIfStorageSupported(): void {
    if (!window.localStorage || !window.sessionStorage) {
      navigateToUnsupported();
      return;
    }
  }
}
